// import the react components
import React, {Fragment} from "react";
import {Link} from "react-router-dom";

// the footer functional based component
const Footer = ({copy = true}) => {
    const footer_items = [
        "about",
        "privacy",
        "guides",
    ];

    // return to the component data
    return (
        <Fragment>
            <br />
            <div className={`flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0 ${copy ? "" : "flex-col"}`}>
                {copy && <p className="text-sm sm:text-base text-gray-800 dark:text-gray-400 text-center sm:text-left">&copy; <span className="font-medium text-gray-900 dark:text-white">2026 LightDent. All rights reserved.</span></p>}
                <div className="flex flex-wrap justify-center sm:justify-end gap-4 sm:gap-6">
                    {footer_items.map(item => <Link to={`/${item}`} key={item} className="relative capitalize text-sm sm:text-base text-gray-900 dark:text-gray-400 transition-all duration-200 after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-[1px] after:bg-gray-400 after:transition-all after:duration-300 hover:after:w-full">{item}</Link>)}
                </div>
            </div>
        </Fragment>
    );
};
export default Footer;